import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import { map, catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class UsuarioService {
	private url_grupo_2e: string = environment.g2e_api;

	private httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	};

	constructor(private http: HttpClient) { }

	public async findAll(): Promise<Array<any>> {
		return await this.http
			.get<any>(`${this.url_grupo_2e}usuario`, this.httpOptions)
			.pipe(
				map((response: any) => response.data),
				catchError((error) => throwError(() => error))
			)
			.toPromise();
	}
	
}
